import type { Options as IconOptions } from 'ol/style/Icon'
import { Icon, Style } from 'ol/style'

import devicesSpriteSheet from '@/resources/map-markers/devicesAndVehicles.png'

import { genericStyles } from '../../genericStyles'

const deviceOutlineStylesCache: Map<string, Style> = new Map()

export const getDeviceOutlineFeatureStyle = (
  marker: uui.domain.ui.map.markers.Device,
  mode: uui.domain.ui.map.markers.MapStyles['device']['mode'],
) => {
  if (mode === 'off' || !marker.outlineGrid) return genericStyles.hidden

  const coordinates = marker.outlineGrid

  const spriteSheetUrl = devicesSpriteSheet
  const cellSize = coordinates[2]
  const x = coordinates[0]
  const y = coordinates[1]

  const cacheId = `${x}_${y}`

  if (deviceOutlineStylesCache.has(cacheId)) {
    const cachedStyle = deviceOutlineStylesCache.get(cacheId)

    if (cachedStyle) return cachedStyle
  }

  const opts: IconOptions = {
    anchor: [0.5, 0.5],
    anchorOrigin: 'top-left',
    anchorYUnits: 'fraction',
    anchorXUnits: 'fraction',
  }

  const style = new Style({
    image: new Icon({
      src: spriteSheetUrl,
      crossOrigin: 'anonymous',

      scale: 0.5,
      opacity: 1.0,
      rotation: 0.0,
      rotateWithView: true,

      size: [cellSize, cellSize],
      offset: [x, y],

      ...opts,
    }),
  })

  deviceOutlineStylesCache.set(cacheId, style)

  return style
}
